// extracted by mini-css-extract-plugin
module.exports = {"theme":"#155bd4"};